import API from "./api";

export const GetAppConfigs = (configUrl: string) => API.get(`${configUrl}api/Config/ReactAppPortalKeys`)